import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { CrPolicyCheckComponent } from './policy-check.component';

export const Ng1PolicyCheckModule = angular
  .module('control-room.angular.policy-check', [])
  .directive('crPolicyCheck', downgradeComponent({ component: CrPolicyCheckComponent, inputs: ['crAction'] }));
